import { COLORS, URLS } from '@/constants/calculator';

const FOOTER_BG_STYLE = { backgroundColor: COLORS.PURPLE };
const CTA_BTN_STYLE = { backgroundColor: COLORS.ORANGE };

const handleCtaMouseEnter = (e) => {
  e.target.style.backgroundColor = COLORS.ORANGE_DARK;
};
const handleCtaMouseLeave = (e) => {
  e.target.style.backgroundColor = COLORS.ORANGE;
};

export const FooterCTA = () => (
  <div className="mt-8 p-12 text-center text-white" style={FOOTER_BG_STYLE}>
    <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold mb-4">
      Ready for Professional Ducting Installation?
    </h2>
    <p className="text-lg mb-8 text-purple-100 max-w-2xl mx-auto">
      ARLO Express Sheetmetals delivers precision, quality, and reliability with over 60 installation experts
    </p>
    <a
      href={URLS.CONTACT_PAGE}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block font-bold text-lg px-8 py-4 transition-all duration-200 text-white hover:text-white"
      style={CTA_BTN_STYLE}
      onMouseEnter={handleCtaMouseEnter}
      onMouseLeave={handleCtaMouseLeave}
      data-testid="contact-cta"
    >
      GET INSTALLATION QUOTE
    </a>
  </div>
);
